import { call, select, put, all, takeLatest } from "redux-saga/effects";
import {
  selectFormReqLeave,
  selectRequestLeaveDetailData,
} from "../redux/selector";
import { createReqLeaveApi } from "core/http/service/timeKeeping";
import {
  createReqLeaveFailed,
  createReqLeaveStart,
  createReqLeaveSuccess,
} from "../redux/createReqLeave";
import { toast } from "react-toastify";
import {
  formReqLeaveReset,
  formReqLeaveUpdate,
  resetFormLeaveLongTerm,
  TypeSelect,
} from "../redux/formReqLeave";
import moment from "moment";

function* createReqLeaveWork(action) {
  const { screenCode } = action.payload;
  const { data, longTerm } = yield select(selectFormReqLeave);
  const dataDetail = yield select(selectRequestLeaveDetailData);
  try {
    const newFormData = {
      ...data,
      id: dataDetail?.id || undefined,
      relatedPersonCodes: data?.relatedPersonCodes?.map((it) => it?.value),
      approvals: data?.approvals?.map((it) => it?.value),
      files: data?.files?.filter((it) => !!it),
      details: [
        ...(data?.type === TypeSelect.SHORT_TERM
          ? data?.details
              ?.filter((detail) => {
                if (dataDetail?.id) {
                  return (
                    dataDetail?.details?.some(
                      (it) =>
                        moment(it?.fromDate)?.toISOString() ===
                        detail?.fromDate?.toISOString()
                    ) && detail?.reasonCode
                  );
                }
                return detail?.isNew && detail?.reasonCode;
              })
              ?.map((it) => ({
                ...it,

                fromDate: it?.fromDate?.toISOString() ?? "",
                toDate: it?.toDate?.toISOString() ?? "",
              }))
          : [
              {
                ...longTerm,
                fromDate: longTerm?.fromDate?.toISOString(),
                toDate: longTerm?.toDate?.toISOString(),
              },
            ]),
      ],
    };
    const res = yield call(createReqLeaveApi, newFormData, screenCode);
    if (res) {
      yield put({
        type: createReqLeaveSuccess.type,
      });
      yield put({
        type: resetFormLeaveLongTerm.type,
      });
      yield put({
        type: formReqLeaveReset.type,
      });
      action.payload?.callback?.();
      toast.success(`Đơn xin nghỉ của bạn đã được gửi thành công`);
    }
  } catch (err: any) {
    yield put({
      type: createReqLeaveFailed.type,
    });
    yield put({
      type: formReqLeaveUpdate.type,
      payload: {
        files_file_contents: [],
        files_files: [],
      },
    });
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra !");
  }
}

function* watchCreateReqLeave() {
  yield takeLatest(createReqLeaveStart.type, createReqLeaveWork);
}

export default function* createReqLeaveSaga() {
  yield all([watchCreateReqLeave()]);
}
